import type {DocumentoDeCarpeta} from '@cnc/contracts';
import {tr} from '../i18n/idioma';

const boton = 'rounded-md border border-linea px-3 py-1.5 text-sm hover:bg-fondo disabled:opacity-50';

// Documentos que tienen que estar en la carpeta (decision 0085): nombre,
// palabras del nombre del archivo que lo reconocen, las que lo descartan y la
// subcarpeta donde va.
export function ListaDeChequeo({
  documentos: docs,
  sugeridos,
  cambiar,
}: {
  documentos: DocumentoDeCarpeta[];
  sugeridos: () => DocumentoDeCarpeta[];
  cambiar: (d: DocumentoDeCarpeta[]) => void;
}) {
  const poner = (i: number, cambio: Partial<DocumentoDeCarpeta>) =>
    cambiar(docs.map((d, j) => (j === i ? {...d, ...cambio} : d)));
  const chico = 'w-full rounded-md border border-linea px-2 py-1 text-sm text-tinta';
  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="font-medium">
          {tr(`Lista de chequeo (${docs.length} documentos)`, `Checklist (${docs.length} documents)`)}
        </span>
        <span className="flex gap-2">
          <button type="button" className={boton} onClick={() => cambiar(sugeridos())}>
            {tr('Usar la lista sugerida', 'Use the suggested list')}
          </button>
          <button
            type="button"
            className={boton}
            onClick={() =>
              cambiar([...docs, {nombre: '', palabras: '', excepto: '', subcarpeta: '', obligatorio: true}])
            }
          >
            {tr('+ Documento', '+ Document')}
          </button>
        </span>
      </div>
      {docs.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-xs text-apagado">
              <tr>
                <th className="pr-2">{tr('Documento', 'Document')}</th>
                <th className="pr-2">
                  {tr(
                    'Palabras del nombre (separadas por coma; * = cualquier archivo de su subcarpeta)',
                    'Name words (comma separated; * = any file in its subfolder)',
                  )}
                </th>
                <th className="pr-2">{tr('Excepto', 'Except')}</th>
                <th className="pr-2">{tr('Subcarpeta', 'Subfolder')}</th>
                <th className="pr-2">{tr('Obligatorio', 'Required')}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {docs.map((d, i) => (
                <tr key={i}>
                  <td className="pr-2 py-1">
                    <input value={d.nombre} onChange={e => poner(i, {nombre: e.target.value})} className={chico} />
                  </td>
                  <td className="pr-2 py-1">
                    <input value={d.palabras} onChange={e => poner(i, {palabras: e.target.value})} className={chico} />
                  </td>
                  <td className="pr-2 py-1">
                    <input value={d.excepto} onChange={e => poner(i, {excepto: e.target.value})} className={chico} />
                  </td>
                  <td className="pr-2 py-1">
                    <input
                      value={d.subcarpeta}
                      onChange={e => poner(i, {subcarpeta: e.target.value})}
                      className={chico}
                    />
                  </td>
                  <td className="pr-2 py-1 text-center">
                    <input
                      type="checkbox"
                      checked={d.obligatorio}
                      onChange={e => poner(i, {obligatorio: e.target.checked})}
                      className="accent-verde"
                    />
                  </td>
                  <td className="py-1">
                    <button
                      type="button"
                      className="text-alerta hover:underline"
                      onClick={() => cambiar(docs.filter((_, j) => j !== i))}
                    >
                      {tr('Quitar', 'Remove')}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
